/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import { featureEnabled } from 'lib/helpers'; // eslint-disable-line import/order

import PartnerPopupController from 'components/partner/partner-popup-controller';
EezyStimulusApplication.register('partner-popup', PartnerPopupController);

import PromoPopupController from 'global/promos/promo_popup_component/promo-popup-controller';
EezyStimulusApplication.register('promo-popup', PromoPopupController);

import CountdownTimerController from 'components/util/countdown-timer/countdown-timer-controller';
EezyStimulusApplication.register('countdown-timer', CountdownTimerController);

import CartAbandonmentCountdownTimerController from 'components/util/countdown-timer/cart-abandonment-countdown-timer-controller';
EezyStimulusApplication.register('cart-abandonment-countdown-timer', CartAbandonmentCountdownTimerController);

import CustomerFeedbackComponentController from 'customer_feedbacks/customer_feedback_component/customer-feedback-component-controller';

import CustomerFeedbackFormController from 'customer_feedbacks/customer_feedback_component/customer-feedback-form-controller';

if (featureEnabled('customer_feedback')) {
  EezyStimulusApplication.register('customer-feedback-component', CustomerFeedbackComponentController);

  EezyStimulusApplication.register('customer-feedback-form', CustomerFeedbackFormController);

  import('customer_feedbacks/customer_feedback_component/customer_feedback.js');
}
